export default {
  BLACK: '#1c1c1c',
  WHITE: '#fff',
  WHITE_GRAY: '#f7f7f7',
  LIGHT_GRAY: '#eee',
  GRAY: '#707070',
  RED: '#dd104c',
  THEMA: '#ddae27',
}
